import { cwslapi } from "../index";

// 获取vip信息 —— 账户中心
export const getVipInfoApi = (data) => { 
  return cwslapi({
    url: "/account/getVipInfo",
    method: "post",
    data,
  });
};


// 我的钱包游戏划分 —— 账户中心
export const getToDivideApi = (data) => { 
    return cwslapi({
      url: "/account/toDivide",
      method: "post",
      data,
    });
  };
  
// 领取vip奖励 —— 账户中心
export const getVipPrizeApi = (data) => { 
    return cwslapi({
      url: "/account/getVipPrize",
      method: "post",
      data,
    });
  };